import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus } from "lucide-react";

const faqs = [
  { q: "Os veículos têm procedência garantida?", a: "Sim. Todos os veículos passam por vistoria cautelar completa, checagem de histórico, leilão, sinistro e restrições antes de entrar no estoque." },
  { q: "Como funciona a simulação de financiamento?", a: "Você ajusta valor, entrada e prazo no simulador e recebe a parcela estimada na hora. Depois, nossa equipe busca a melhor taxa entre os bancos parceiros para o seu perfil." },
  { q: "Posso dar meu carro atual na troca?", a: "Sim. Avaliamos seu veículo com dados de mercado em tempo real e o valor entra como parte do pagamento, direto na simulação." },
  { q: "Vocês entregam em outras cidades?", a: "Sim. Entregamos em todo o Brasil com transporte segurado e rastreado. O contrato e a documentação são 100% digitais." },
  { q: "Como a IA da Seed Motors me atende?", a: "Nosso agente de IA responde no WhatsApp a qualquer hora: tira dúvidas sobre veículos, envia fotos, simula parcelas e agenda sua visita ao showroom." },
  { q: "Sou lojista. Posso usar o sistema da Seed na minha revenda?", a: "Sim. Nossa plataforma ERP + CRM (site, integrador de anúncios, funil de leads, IA, financeiro e NF-e) também atende outras revendas. Fale com a gente pelo formulário." },
];

export const Faq = () => {
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" className="py-24 sm:py-32" data-testid="faq-section">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8 }}
          className="mb-12"
        >
          <p className="text-xs font-mono2 tracking-widest uppercase text-emerald-400 mb-3">06 — FAQ</p>
          <h2 className="font-display text-3xl sm:text-5xl font-bold tracking-tight text-white">
            Perguntas <span className="text-emerald-400">frequentes</span>
          </h2>
        </motion.div>

        <div className="space-y-3" data-testid="faq-list">
          {faqs.map((f, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.06 }}
              className={`rounded-2xl border transition-colors duration-300 overflow-hidden ${
                open === i ? "border-emerald-500/40 bg-[#131620]" : "border-slate-800/60 bg-[#0d0f17]"
              }`}
              data-testid={`faq-item-${i}`}
            >
              <button
                onClick={() => setOpen(open === i ? -1 : i)}
                className="w-full flex items-center justify-between gap-4 px-6 py-5 text-left"
                data-testid={`faq-toggle-${i}`}
              >
                <span className="font-display font-semibold text-white">{f.q}</span>
                <Plus className={`w-5 h-5 shrink-0 text-emerald-400 transition-transform duration-300 ${open === i ? "rotate-45" : ""}`} />
              </button>
              <AnimatePresence initial={false}>
                {open === i && (
                  <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: "auto", opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
                  >
                    <p className="px-6 pb-6 text-sm text-slate-400 leading-relaxed" data-testid={`faq-answer-${i}`}>{f.a}</p>
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
